class PasswordModal extends DetailsModal {
  constructor() {
    super();

    if (this.querySelector('input[aria-invalid="true"]')) this.open({ target: this.querySelector('details') });
  }
}

customElements.define('password-modal', PasswordModal);
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector("password-modal");
  const footer = document.querySelector("footer");

  if (modal && footer) {
    footer.appendChild(modal);
  }
});